<template>
	<div>
		<h2 class="">HotSchedules Academy Mappings</h2>
		<div class="academy-listings">
			<v-client-table :data="tableData" :columns="columns" :options="options"></v-client-table>
		</div>
	</div>
</div>
</template>

<script>
import _ from 'underscore'
import store from '../data/AppData'

const rowMapper = row => {
	return {
		'Mappings': row.mappings.length,
		'Academy ID': row.id,
		'Academy Name': row.name,
		'Customer': row.company
	}
}

export default {
	data () {
		return {
			columns: [ 'Customer', 'Academy ID', 'Academy Name', 'Mappings', 'Details' ],
			options: {
				perPage: 25,
				templates: {
					'Details': (h, row) => { return h('details-link', { attrs: { 'id': row['Academy ID'] } }) }
				}
			}
		}
	},
	computed: {
		tableData () {
			return _.map(this.$store.state.academiesList, rowMapper)
		}
	},
	beforeRouteEnter (to, from, next) {
		if (store.state.academiesLoaded) return next()
		store.dispatch('getAcademies').then(res => next())
	}
}
</script>

<style>
.academy-listings th{
	vertical-align: top !important;
}
.academy-listings tr td, .academy-listings tr th{
	text-align: center;
}

.academy-listings tr td:nth-child(1), .academy-listings tr td:nth-child(3),
.academy-listings tr th:nth-child(1), .academy-listings tr th:nth-child(3) {
	text-align: left;
}
</style>


// WEBPACK FOOTER //
// List.vue?ea644f8c